import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Page } from '../components/Layout'
import { ErrorBox, Field, TextInput } from '../components/ui'
import { useAuth } from '../hooks/useAuth'
import { supabase } from '../lib/supabase'
import { apiPost } from '../lib/api'

// /ativar?cliente=<id>&token=<invite_token>
// Fluxo: login por magic link -> ao voltar autenticado, vincula a conta via /api/conta/vincular.
export default function Ativar() {
  const [params] = useSearchParams()
  const clienteId = params.get('cliente') ?? ''
  const token = params.get('token') ?? ''
  const { user, loading } = useAuth()

  const [email, setEmail] = useState('')
  const [enviado, setEnviado] = useState(false)
  const [erro, setErro] = useState<string | null>(null)
  const [vinculado, setVinculado] = useState(false)

  useEffect(() => {
    if (!loading && user && clienteId && token && !vinculado) {
      apiPost<{ ok: boolean }>('/api/conta/vincular', { cliente_id: clienteId, invite_token: token }, { auth: true })
        .then(() => setVinculado(true))
        .catch((e) => setErro((e as Error).message))
    }
  }, [loading, user, clienteId, token, vinculado])

  async function enviarMagicLink(e: React.FormEvent) {
    e.preventDefault()
    setErro(null)
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.href },
    })
    if (error) setErro(error.message)
    else setEnviado(true)
  }

  if (!clienteId || !token) {
    return (
      <Page>
        <div className="card">
          <h1 className="text-xl font-semibold text-pfa-navy">Link de ativação inválido</h1>
          <p className="mt-2 text-pfa-slate">Use o link enviado por e-mail após a contratação.</p>
        </div>
      </Page>
    )
  }

  if (vinculado) {
    return (
      <Page>
        <div className="card">
          <h1 className="text-xl font-semibold text-pfa-navy">Conta ativada</h1>
          <p className="mt-2 text-pfa-slate">Tudo certo! Agora você pode acompanhar seu caso e enviar documentos.</p>
          <div className="mt-4 flex gap-3">
            <Link to="/painel" className="btn-primary">
              Acompanhar meu caso
            </Link>
            <Link to="/documentos" className="btn-ghost">
              Enviar documentos
            </Link>
          </div>
        </div>
      </Page>
    )
  }

  return (
    <Page>
      <div className="card max-w-md">
        <h1 className="text-xl font-semibold text-pfa-navy">Ativar meu acesso</h1>
        {user ? (
          <p className="mt-2 text-pfa-slate">Vinculando sua conta…</p>
        ) : enviado ? (
          <p className="mt-2 text-pfa-slate">Enviamos um link de acesso para <strong>{email}</strong>. Abra o e-mail para entrar.</p>
        ) : (
          <form onSubmit={enviarMagicLink} className="mt-4">
            <Field label="Seu e-mail" hint="Enviaremos um link de acesso seguro.">
              <TextInput type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </Field>
            <ErrorBox message={erro} />
            <button className="btn-accent mt-2" type="submit">
              Receber link de acesso
            </button>
          </form>
        )}
        <ErrorBox message={erro} />
      </div>
    </Page>
  )
}
